// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"093652be","317":"7e987e9d","535":"c4e6866b","572":"f5a0718f","697":"4687ca0f","807":"0c37b069","977":"fbac28d8"}[chunkId] + ".chunk.js";
};